import { Component, ViewChild, ChangeDetectorRef } from '@angular/core';
import { IonicPage, NavController, NavParams, MenuController, ViewController, ModalController, Events, ToastController, Content } from 'ionic-angular';
import { Tabs as Tab } from 'ionic-angular';
import { Page } from '../../enums/page.enum';
import { Storage } from '@ionic/storage';
import { BadgeService } from '../../services/badge.service';
import { TransactionService } from '../../services/transaction.service';
import { StorageService } from '../../services/storage.service';
import * as _ from "lodash";
import { Observable } from 'rxjs/rx';
import { UtilService } from '../../services/util.service';



@IonicPage()
@Component({
  templateUrl: 'tabs.html'
})
export class Tabs {
  tab1Root: any = 'Customer';
  tab2Root: any = 'Product';
  tab3Root: any = 'OrderList';
  tab4Root: any = 'TxnHistory';
  tab5Root: any = 'TrackOrder';
  tab6Root: any = 'UserProfile';
  tab7Root: any = 'TrackReturnOrder';
  tab9Root: any = 'CustomerSearchPage';

  mySelectedIndex: number;
  @ViewChild('myTabs') tabRef: Tab;
  @ViewChild(Content) content: Content;
  salesInd = { salesInd: "S" };
  params = { refresh: false };
  subscriber: any;
  token: string;
  refresh: Boolean = true;
  isVN: Boolean = false;

  showCust: Boolean = true;
  showProduct: Boolean = true;
  showOrder: Boolean = true;
  showTxnHist: Boolean = true;
  showOrderStatus: Boolean = true;
  isDisplayWarningNotification: boolean = false;
  warningNotification: string = '';
  isViewDestroyed: boolean = false;

  // Events: update-order-detail
  subscription = Observable.interval(15000).take(9999999).map(() => {
    this.storage.get('user').then((user) => {
      if (_.isEmpty(user)) {
        return;
      }
      this.storage.get('order').then((order) => {
        if (_.isEmpty(order)) {
          return; 
        }

        this.storage.get('uploadedOrder').then((uploadedOrder) => {
          if (uploadedOrder != null && _.isEqual(uploadedOrder, order)) {
              return;
          }

          this.transactionService.updateTempTxnOrderDetail(order, this.storageService.getSettingId(), this.storageService.getUserId()).subscribe(
            () => { this.storage.set('uploadedOrder', order); }, () => { this.subscriber.unsubscribe(); });
        })
      })
    });
  });

  constructor(private events: Events
    , public menu: MenuController
    , private badgeService: BadgeService
    , private transactionService: TransactionService
    , private storage: Storage
    , public storageService: StorageService
    , public modalCtrl: ModalController
    , public toastCtrl: ToastController
    , private changeDetectorRef: ChangeDetectorRef
    , private util: UtilService
  ) {
    try {
      this.isVN = this.util.isRemoveDKSHLogoForVN();
      if(!this.isVN) window.addEventListener('resize', this.resizeModal);
      window.addEventListener('resize', this.resizeModal);    

      events.subscribe('update-order-detail', (action: string, token: string) => {
        switch (action) {
          case "start":
            this.token = token;
            if (this.subscriber != undefined) {
              if (this.subscriber.closed) {
                this.subscriber = this.subscription.subscribe();
              }
            }
            else
              this.subscriber = this.subscription.subscribe();
            break;
          case "stop":
            if (this.subscriber != undefined) {
              if (!this.subscriber.closed) {
                this.subscriber.unsubscribe();
              }
            }
        }
      })

      events.subscribe('change-tab', (tab: number) => {
        this.tabRef.select(tab);
      })

      events.subscribe('change-tab-params', (tab: number, params: any) => {
        if (tab == Page.OrderList) {
          this.storageService.setSalesInd(params.salesInd);
          this.salesInd.salesInd = params.salesInd;

          if (this.tabRef._tabs.find((r) => { return r.isSelected == true }).root == "OrderList") {
            window.location.reload();
            return;
          }
        }
        else if (tab == Page.CustomerList) {
          this.storageService.setSalesInd(params.salesInd);
        }
        
        else if (tab == Page.ProductList){
          this.params.refresh = params;
        }
        this.tabRef.select(tab);
      });
      this.menu.swipeEnable(true);

      events.subscribe('display-warning-notification', (isDisplay: boolean, msg: string) => {
        // To avoid redirect to tabs after SSO complete. Login page already destroyed
        if (!this.isViewDestroyed) {
          this.isDisplayWarningNotification = isDisplay
          this.warningNotification = msg;
          this.changeDetectorRef.detectChanges();
          this.content.resize();
        }
      });
    } catch (error) {
      // TODO: Handle error
    }
  }

  ngOnInit(){

  }

  ionViewDidEnter() {
    this.storage.get('order').then((order) => {
      if (order) {
        if (order.detail.length > 0) {
          this.badgeService.incrementBadgeByValue(order.detail.length);
        }
      }
    });

    this.storage.get('notice_message').then(
      (value) => {
        if (!_.isEmpty(value)) {
            this.events.publish('display-warning-notification', true, value);
        } else {
            this.events.publish('display-warning-notification', false, '');
        }
      }
    );
  }

  ionViewDidLoad() {
    this.storage.get('user').then((user) => {

      if (user) {
        // 0 - Customer
        // 1 - Product
        // 2 - Order
        // 3 - FOC Order
        // 4 - Order Status
        // 5 - Txn History
        // 6 - Change salesrep
        // 7 - Return order status
        // 8 - Consignment order

        const access = user?.accessright_list || [];
        this.showCust = access[0].visible == '1' ? true : false;
        this.showProduct = access[1].visible == '1' ? true : false;
        // Order Page will be shown only if the user has access to either Normal Order or FOC Order or Consignment Order
        this.showOrder = ['2', '3', '8'].some(i => access[i]?.visible === '1');
        this.showTxnHist = access[5].visible == '1' ? true : false;
        this.showOrderStatus = access[4].visible == '1' ? true : false;

        if (access[0].visible == '0' && access[4].visible == '1') {
          this.tabRef.select(Page.OrderStatusList);
        }
      }
    });
  }

  ionViewDidLeave() {
    this.events.unsubscribe('change-tab');
    this.events.unsubscribe('change-tab-params');
    window.removeEventListener('resize', this.resizeModal);
  }

  showTermAndCondition() {
    let tabbar = document.getElementsByClassName('tabbar')[0];
    let topCaculatedOffset = tabbar.clientHeight * 2 + 10;
    document.documentElement.style.setProperty('--top-offset', topCaculatedOffset + 'px');
    let bottomCaculatedOffset = document.getElementById('eo-footer-in').offsetHeight;
    document.documentElement.style.setProperty('--bottom-offset', bottomCaculatedOffset + 'px');

    let screenHeight = (window.innerHeight - bottomCaculatedOffset - topCaculatedOffset) + 'px';
    document.documentElement.style.setProperty('--screen-height', screenHeight );

    let TermAndConditionModal = this.modalCtrl.create('TermAndCondition',{},
        { enableBackdropDismiss: false, cssClass: 'modal-fullscreen' }
    );
    TermAndConditionModal.present();
  }

  resizeModal() {
    let tabbar = document.getElementsByClassName('tabbar')[0];
    let topCaculatedOffset = tabbar.clientHeight * 2 + 10;
    document.documentElement.style.setProperty('--top-offset', topCaculatedOffset + 'px');
    let bottomCaculatedOffset = document.getElementById('eo-footer-in').offsetHeight;
    document.documentElement.style.setProperty('--bottom-offset', bottomCaculatedOffset + 'px');

    let screenHeight = (window.innerHeight - bottomCaculatedOffset - topCaculatedOffset) + 'px';
    document.documentElement.style.setProperty('--screen-height', screenHeight );
  }

  ngOnDestroy(): void {
    this.isViewDestroyed = true;
  }
}


// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts